// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Container and motion of the "Continue Playing" toast. Reproduces what react-toastify's stylesheet
 * and the overrides on its classes produced together, so the toast sits where it did and bounces in
 * and out the same way.
 */
.X2HUompszgMes2ZpoTUx {
  position: fixed;
  z-index: 9999;
  bottom: max(16px, env(safe-area-inset-bottom));
  right: max(16px, env(safe-area-inset-right));
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: end;
  width: fit-content;
  color: #fff;
}
/* Mobile portrait - right-aligned with 8px padding */
@media (max-width: 1023px) and (orientation: portrait) {
  .X2HUompszgMes2ZpoTUx {
    bottom: 113px;
    right: 0;
    padding: 0 8px;
  }
}
/* Narrow phones - full width */
@media (max-width: 480px) {
  .X2HUompszgMes2ZpoTUx {
    width: 100vw;
    left: env(safe-area-inset-left);
  }
}
/* Mobile landscape - positioned on right */
@media (max-width: 1023px) and (orientation: landscape) {
  .X2HUompszgMes2ZpoTUx {
    bottom: 96px;
    left: auto;
    right: 16px;
    width: auto;
  }
}
/* Desktop */
@media (min-width: 1024px) {
  .X2HUompszgMes2ZpoTUx {
    bottom: 120px;
    right: 16px;
    width: 556px;
    /* 540px toast + 16px padding */
    max-width: calc(100vw - 32px);
  }
}
.FoCySVQYq7xp7vCVBhuU {
  position: relative;
  z-index: 0;
  box-sizing: border-box;
  min-height: 64px;
  display: flex;
  align-items: center;
  touch-action: none;
  word-break: break-word;
}
/* Mobile portrait - full width, toast right-aligned */
@media (max-width: 1023px) and (orientation: portrait) {
  .FoCySVQYq7xp7vCVBhuU {
    width: 100%;
    justify-content: flex-end;
  }
}
/* Mobile landscape - auto width */
@media (max-width: 1023px) and (orientation: landscape) {
  .FoCySVQYq7xp7vCVBhuU {
    display: block;
  }
}
/* Desktop */
@media (min-width: 1024px) {
  .FoCySVQYq7xp7vCVBhuU {
    display: block;
    width: 540px;
    min-width: 540px;
  }
}
@supports selector(:has(*)) {
  /* Search open: the nav is hidden, so the container collapses out of the way */
  .X2HUompszgMes2ZpoTUx:has(.isSearchActive) {
    width: 0;
    overflow: hidden;
    padding: 0;
  }
  /* Continue Playing OFF: collapse the toast so it can't intercept clicks */
  .FoCySVQYq7xp7vCVBhuU:has([data-continue-playing='off']) {
    display: none;
  }
}
.M8Rt04yz6UsBIfO6EAea {
  animation: yhwKIqmJXFXmzxfjNcKJ 0.5s both;
}
.Fv3MiRYTUAh_0Et8cfhq {
  animation: PrCCUzsFh_1UY88dqxdA 0.5s both;
}
@keyframes yhwKIqmJXFXmzxfjNcKJ {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes PrCCUzsFh_1UY88dqxdA {
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/games/components/BackToGameToast/BackToGameToastHost.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,eAAe;EACf,aAAa;EACb,8CAA8C;EAC9C,4CAA4C;EAC5C,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA,qDAAqD;AACrD;EACE;IACE,aAAa;IACb,QAAQ;IACR,cAAc;EAChB;AACF;AACA,+BAA+B;AAC/B;EACE;IACE,YAAY;IACZ,+BAA+B;EACjC;AACF;AACA,2CAA2C;AAC3C;EACE;IACE,YAAY;IACZ,UAAU;IACV,WAAW;IACX,WAAW;EACb;AACF;AACA,YAAY;AACZ;EACE;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,6BAA6B;EAC/B;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;AACA,sDAAsD;AACtD;EACE;IACE,WAAW;IACX,yBAAyB;EAC3B;AACF;AACA,kCAAkC;AAClC;EACE;IACE,cAAc;EAChB;AACF;AACA,YAAY;AACZ;EACE;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;EACE,8EAA8E;EAC9E;IACE,QAAQ;IACR,gBAAgB;IAChB,UAAU;EACZ;EACA,0EAA0E;EAC1E;IACE,aAAa;EACf;AACF;AACA;EACE,yCAAkC;AACpC;AACA;EACE,yCAAmC;AACrC;AACA;EACE;;;;;IAKE,8DAA8D;EAChE;EACA;IACE,UAAU;IACV,oCAAoC;EACtC;EACA;IACE,UAAU;IACV,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,UAAU;IACV,mCAAmC;EACrC;EACA;IACE,UAAU;IACV,oCAAoC;EACtC;AACF","sourcesContent":["/*\n * Container and motion of the \"Continue Playing\" toast. Reproduces what react-toastify's stylesheet\n * and the overrides on its classes produced together, so the toast sits where it did and bounces in\n * and out the same way.\n */\n.container {\n  position: fixed;\n  z-index: 9999;\n  bottom: max(16px, env(safe-area-inset-bottom));\n  right: max(16px, env(safe-area-inset-right));\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n  width: fit-content;\n  color: #fff;\n}\n/* Mobile portrait - right-aligned with 8px padding */\n@media (max-width: 1023px) and (orientation: portrait) {\n  .container {\n    bottom: 113px;\n    right: 0;\n    padding: 0 8px;\n  }\n}\n/* Narrow phones - full width */\n@media (max-width: 480px) {\n  .container {\n    width: 100vw;\n    left: env(safe-area-inset-left);\n  }\n}\n/* Mobile landscape - positioned on right */\n@media (max-width: 1023px) and (orientation: landscape) {\n  .container {\n    bottom: 96px;\n    left: auto;\n    right: 16px;\n    width: auto;\n  }\n}\n/* Desktop */\n@media (min-width: 1024px) {\n  .container {\n    bottom: 120px;\n    right: 16px;\n    width: 556px;\n    /* 540px toast + 16px padding */\n    max-width: calc(100vw - 32px);\n  }\n}\n.toast {\n  position: relative;\n  z-index: 0;\n  box-sizing: border-box;\n  min-height: 64px;\n  display: flex;\n  align-items: center;\n  touch-action: none;\n  word-break: break-word;\n}\n/* Mobile portrait - full width, toast right-aligned */\n@media (max-width: 1023px) and (orientation: portrait) {\n  .toast {\n    width: 100%;\n    justify-content: flex-end;\n  }\n}\n/* Mobile landscape - auto width */\n@media (max-width: 1023px) and (orientation: landscape) {\n  .toast {\n    display: block;\n  }\n}\n/* Desktop */\n@media (min-width: 1024px) {\n  .toast {\n    display: block;\n    width: 540px;\n    min-width: 540px;\n  }\n}\n@supports selector(:has(*)) {\n  /* Search open: the nav is hidden, so the container collapses out of the way */\n  .container:has(:global(.isSearchActive)) {\n    width: 0;\n    overflow: hidden;\n    padding: 0;\n  }\n  /* Continue Playing OFF: collapse the toast so it can't intercept clicks */\n  .toast:has([data-continue-playing='off']) {\n    display: none;\n  }\n}\n.enter {\n  animation: bounceInRight 0.5s both;\n}\n.exit {\n  animation: bounceOutRight 0.5s both;\n}\n@keyframes bounceInRight {\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(-5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes bounceOutRight {\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `X2HUompszgMes2ZpoTUx`,
	"toast": `FoCySVQYq7xp7vCVBhuU`,
	"enter": `M8Rt04yz6UsBIfO6EAea`,
	"bounceInRight": `yhwKIqmJXFXmzxfjNcKJ`,
	"exit": `Fv3MiRYTUAh_0Et8cfhq`,
	"bounceOutRight": `PrCCUzsFh_1UY88dqxdA`
};
export default ___CSS_LOADER_EXPORT___;
